import { render } from "./NotificationModal.vue?vue&type=template&id=55f656fc&ts=true"
import script from "./NotificationModal.vue?vue&type=script&lang=ts"
export * from "./NotificationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__